import { Group } from '@unistocks/components/group/group';
import { Card, CardProps } from '@unistocks/components/layout/card';
import { Page } from '@unistocks/components/page/page';
import { AssetDto } from '@unistocks/proxy/axios-client';
import { formatCurrency, t } from '@unistocks/shared/localization/index.ts';
import { assetTypeOptions } from '@unistocks/shared/utils/enums/asset-type-options';
import { isNumber } from '@unistocks/shared/utils/util';
import { ListItem, Separator } from 'tamagui';

export type AssetSummaryProps = {
  asset: AssetDto;
} & CardProps;

export const AssetSummary: React.FC<AssetSummaryProps> = ({ asset, ...props }) => {
  const assetType = assetTypeOptions.find(option => option.value === asset.type);

  return (
    <Page.Content {...props}>
      <Page.Content.Header p={0}>
        <Card.Heading>{t('::Asset:Summary')}</Card.Heading>
      </Page.Content.Header>
      <Group separator={<Separator />}>
        <Group.Item>
          <ListItem title={t('::Name')} subTitle={asset.name} testID="asset-summary-name" />
        </Group.Item>
        {assetType ? (
          <Group.Item>
            <ListItem
              title={t('::AssetType')}
              subTitle={t(assetType.key)}
              testID="asset-summary-type"
            />
          </Group.Item>
        ) : null}
        {asset.symbol ? (
          <Group.Item>
            <ListItem
              title={t('::Asset:Ticker')}
              subTitle={asset.symbol}
              testID="asset-summary-ticker"
            />
          </Group.Item>
        ) : null}
        {asset.isin ? (
          <Group.Item>
            <ListItem title={t('::Asset:ISIN')} subTitle={asset.isin} testID="asset-summary-isin" />
          </Group.Item>
        ) : null}
        {isNumber(asset.currentPrice) ? (
          <Group.Item>
            <ListItem
              title={t('::AssetPrice')}
              subTitle={formatCurrency(asset.currentPrice, asset.currency)}
              testID="asset-summary-price"
            />
          </Group.Item>
        ) : null}
      </Group>
    </Page.Content>
  );
};

AssetSummary.displayName = 'AssetSummary';
